//This will be applied to all components, don't abuse it.
export default {
}
